export enum PullRequestsTableStateVisibility {
  None = 'none',
  All = 'all',
  DraftsOnly = 'drafts-only',
}
